'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactRouter = require('react-router');

var _Link = require('./Link.css');

var _Link2 = _interopRequireDefault(_Link);

var _analytics = require('../../helpers/analytics');

var _analytics2 = _interopRequireDefault(_analytics);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Link = (_dec = (0, _reactCssModules2.default)(_Link2.default, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Link, _Component);

  function Link(props) {
    (0, _classCallCheck3.default)(this, Link);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Link.__proto__ || (0, _getPrototypeOf2.default)(Link)).call(this, props));

    _this.log = function () {
      if (_this.props.log) {
        _analytics2.default.event(_this.props.log);
      }
    };

    return _this;
  }

  (0, _createClass3.default)(Link, [{
    key: 'render',
    value: function render() {
      var title = this.props.title || this.props.to;
      var styleName = 'link';
      if (this.props.strong) {
        styleName = 'strong';
      }
      if (this.props.light) {
        styleName = 'light';
      }
      if (this.props.xstrong) {
        styleName = 'xstrong';
      }
      if (this.props.primarybutton) {
        styleName = 'primarybutton';
      }
      if (this.props.whitebutton) {
        styleName = 'whitebutton';
      }
      if (this.props.orangebutton) {
        styleName = 'orangebutton';
      }
      if (this.props.aboutmenu) {
        styleName = 'aboutmenu';
      }
      if (this.props.aboutmenuactive) {
        styleName = 'aboutmenuactive';
      }
      if (this.props.fundmenu) {
        styleName = 'fundmenu';
      }
      if (this.props.fundmenuactive) {
        styleName = 'fundmenuactive';
      }
      if (this.props.footer) {
        styleName = 'footer';
      }
      if (this.props.bigbutton) {
        styleName = 'bigbutton';
      }
      if (this.props.roundbutton) {
        styleName = 'roundbutton';
      }
      if (this.props.donatebanner) {
        styleName = 'donatebanner';
      }
      if (this.props.to.match(/^#/)) {
        styleName += ' internal';
        return _react2.default.createElement(
          'a',
          { styleName: styleName, onClick: this.log, title: title, href: this.props.to },
          this.props.children
        );
      }
      if (this.props.to.match(/^http/) || this.props.to.match(/^mailto/)) {
        return _react2.default.createElement(
          'a',
          { target: '_blank', onClick: this.log, styleName: styleName, title: title, href: this.props.to },
          this.props.children
        );
      }
      return _react2.default.createElement(
        _reactRouter.Link,
        { styleName: styleName, onClick: this.log, title: title, to: this.props.to },
        this.props.children
      );
    }
  }]);
  return Link;
}(_react.Component), _class2.propTypes = {
  to: _react.PropTypes.string.isRequired,
  strong: _react.PropTypes.bool,
  light: _react.PropTypes.bool,
  xstrong: _react.PropTypes.bool,
  primarybutton: _react.PropTypes.bool,
  whitebutton: _react.PropTypes.bool,
  orangebutton: _react.PropTypes.bool,
  aboutmenu: _react.PropTypes.bool,
  aboutmenuactive: _react.PropTypes.bool,
  fundmenu: _react.PropTypes.bool,
  fundmenuactive: _react.PropTypes.bool,
  footer: _react.PropTypes.bool,
  bigbutton: _react.PropTypes.bool,
  donatebanner: _react.PropTypes.bool,
  roundbutton: _react.PropTypes.bool,
  log: _react.PropTypes.object,
  title: _react.PropTypes.string
}, _temp)) || _class);
exports.default = Link;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/core/Link/Link.js
// module id = 1361
// module chunks = 0